module.exports = [
  'I am a U.S. citizen or lawfully admitted permanent resident (i.e., green card holder).',
  'This contribution is made from my own funds, and funds are not being provided to me by another person or entity for the purpose of making this contribution.',
  'I am at least eighteen years old.',
  'I am not a federal contractor.',
  'I am making this contribution with my own personal credit card and not with a corporate or business credit card or a card issued to another person.',
];
